import { render } from "./ChildFilter.vue?vue&type=template&id=bafe697a"
import script from "./ChildFilter.vue?vue&type=script&lang=js"
export * from "./ChildFilter.vue?vue&type=script&lang=js"

import "./ChildFilter.vue?vue&type=style&index=0&id=bafe697a&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__